import type { FC } from "react";

import { Box, type BoxProps, ChevronDownIcon } from "@hightouch/htui";

export const CollapseChevron: FC<{
  isOpen?: boolean;
  color?: BoxProps["color"];
}> = ({ isOpen, color }) => (
  <Box boxSize={5} color={color}>
    <Box
      as={ChevronDownIcon}
      boxSize={4}
      transform={isOpen ? undefined : "rotate(-90deg)"}
      transitionProperty="transform"
      transitionDuration="faster"
      transitionTimingFunction="easeOutQuad"
    />
  </Box>
);
